<template>
  <nav id="nav">
    <router-link to="/">Home</router-link> 
    |
    <router-link to="/weatherChannel">Weather Channel</router-link>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss">
#nav {
  padding: 30px;
  // box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
